import { createAppAsyncThunk } from '@/domain/store.thunk';

export const checkUserIsConnectedOnStart = createAppAsyncThunk(
  'auth/checkUserIsConnectedOnStart',
  (_, { extra: { authGateway } }) => {
    return authGateway.checkIsSignedIn();
  },
);
